// extracted by mini-css-extract-plugin
export default {"frame":"TP1RV","hidden":"GqPdP"};